/**
 * PasoFirmas — Paso final del AC (Acta de Conformidad). Dos pads de firma:
 * técnico (requerida) y cliente (opcional). Cada trazo se sube a Cloudinary y
 * la URL se guarda en firmas.tecnico / firmas.cliente.
 */
import { SignatureCanvas } from "@/shared/ui/signature-canvas.js";
import type { AcFirmas } from "../../types.js";

const labelClass =
  "font-mono text-[0.625rem] font-medium uppercase tracking-[0.18em] text-muted-foreground";

export function PasoFirmas(props: {
  value: AcFirmas;
  onChange: (next: AcFirmas) => void;
  onError: (msg: string | null) => void;
  disabled?: boolean;
}) {
  const { value, onChange, onError, disabled } = props;

  /** Firma del técnico: requerida → siempre string (no se omite). */
  function setTecnico(url: string) {
    onChange({ ...value, tecnico: url });
  }

  /** Firma del cliente: opcional → vacío elimina la clave. */
  function setCliente(url: string) {
    if (url) {
      onChange({ ...value, cliente: url });
    } else {
      const { cliente: _omit, ...resto } = value;
      onChange(resto);
    }
  }

  return (
    <div className="space-y-6">
      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <span className={labelClass}>Firma del técnico</span>
          <span className="font-mono text-[0.625rem] uppercase tracking-[0.12em] text-brand-accent">
            requerida
          </span>
        </div>
        <SignatureCanvas
          value={value.tecnico}
          onChange={setTecnico}
          onError={onError}
          disabled={disabled}
        />
      </div>

      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <span className={labelClass}>Firma del cliente</span>
          <span className="font-mono text-[0.625rem] uppercase tracking-[0.12em] text-muted-foreground/70">
            opcional
          </span>
        </div>
        <SignatureCanvas
          value={value.cliente ?? ""}
          onChange={setCliente}
          onError={onError}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
